import axios from "axios"
import { OpenAPI } from "../client"
import type { ApiRequestOptions } from "../client/core/ApiRequestOptions"
import { getHeaders, getQueryString } from "../client/core/request"

const parseBlobErrorMessage = async (blob: Blob) => {
  try {
    const text = await blob.text()
    const payload = JSON.parse(text) as { error?: string }
    return payload.error || null
  } catch {
    return null
  }
}

export const MmpDiscrepancyReportApi = {
  async downloadCsv(params?: {
    year?: number
    month?: number
    dateFrom?: string
    dateTo?: string
    status?: string
    reason?: string
    warehouseId?: string
  }) {
    const options: ApiRequestOptions = {
      method: "GET",
      url: "/v1/transfers/reports/mmp-discrepancies/export",
      query: {
        year: params?.year,
        month: params?.month,
        date_from: params?.dateFrom || undefined,
        date_to: params?.dateTo || undefined,
        status: params?.status || undefined,
        reason: params?.reason || undefined,
        warehouse_id: params?.warehouseId || undefined,
      },
    }
    const headers = await getHeaders(OpenAPI, options)
    try {
      const response = await axios.request<Blob>({
        method: options.method,
        url: `${OpenAPI.BASE}${options.url}${options.query ? getQueryString(options.query) : ""}`,
        headers,
        withCredentials: OpenAPI.WITH_CREDENTIALS,
        responseType: "blob",
      })

      return {
        blob: response.data,
        fileName:
          response.headers["content-disposition"]?.match(
            /filename="?([^"]+)"?$/i,
          )?.[1] || "mmp-discrepancies.csv",
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const status = error.response?.status
        const blob = error.response?.data
        const backendMessage =
          blob instanceof Blob ? await parseBlobErrorMessage(blob) : null
        const message =
          status === 429
            ? "Przekroczono dzienny limit eksportów dla licencji. Spróbuj ponownie jutro."
            : backendMessage || "Nie udało się wyeksportować raportu CSV."
        throw new Error(message)
      }
      throw error
    }
  },
}
